import { render, staticRenderFns } from "./TickLine.vue?vue&type=template&id=ffe23810"
import script from "./TickLine.vue?vue&type=script&lang=ts"
export * from "./TickLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports